import React from "react";
import { node, string } from "prop-types";
import Table from "../Table";
import Thead from "../Table/Thead";
import Tbody from "../Table/Tbody";
import Tr from "../Table/Tr";
import Th from "../Table/Th";
import Td from "../Table/Td";

export const CardPriceListItem = ({ amount, price }) => {
	return (
		<Tr>
			<Td>{amount}</Td>
			<Td>{price}</Td>
		</Tr>
	);
};

CardPriceListItem.propTypes = {
	amount: node.isRequired,
	price: node.isRequired,
};

const CardPriceList = ({ colOne, colTwo, children }) => {
	return (
		<Table isBottomBordered className="card-price__list-table">
			<Thead>
				<Tr>
					<Th className="text-nowrap">{colOne}</Th>
					<Th className="text-nowrap">{colTwo}</Th>
				</Tr>
			</Thead>
			<Tbody>{children}</Tbody>
		</Table>
	);
};
CardPriceList.propTypes = {
	colOne: string.isRequired,
	colTwo: string.isRequired,
	children: node.isRequired,
};

CardPriceList.Item = CardPriceListItem;

export default CardPriceList;
